export function entranceEffect() {
    // Check if the #entrance-animation element exists
    const entranceAnimation = document.getElementById('entrance-animation');
    if (!entranceAnimation) {
        return; // Exit if #entrance-animation does not exist
    }

    // Function to get URL parameter by name
    /*function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null
            ? ''
            : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }*/

    // Check if the entrance animation has been shown before or if the URL parameter 'showanimation' is set to 'true'
    /*if (
        !localStorage.getItem('animationEntranceShown') ||
        getUrlParameter('showanimation') === 'true'
    ) {*/
    // Prevent the body from scrolling while the entrance animation is playing
    document.body.classList.add('no-scroll');

    // Add a top margin to #content to push it below the viewport
    const content = document.getElementById('content');
    if (content) {
        content.style.marginTop = '100vh';
    }

    // Flag to track if the animation has been processed
    let animationProcessed = false;

    // Function to end the entrance animation
    function endEntranceAnimation() {
        // Check if the animation has already been processed
        if (animationProcessed) return;
        animationProcessed = true;

        // Remove the no-scroll class to allow scrolling again
        document.body.classList.remove('no-scroll');

        // Smoothly scroll to the #viral-tribe-header element
        const header = document.getElementById('viral-tribe-header');
        if (header) {
            header.scrollIntoView({ behavior: 'smooth' });
        }

        // Hide the #entrance-animation element
        setTimeout(() => {
            if (entranceAnimation) {
                entranceAnimation.style.display = 'none';
            }

            // Remove the top margin from #content to bring it back to its original position
            if (content) {
                content.style.marginTop = '0';
            }
        }, 250); // Adjust the timeout if needed
    }

    // Use MutationObserver to wait until all child elements have finished rendering
    const observer = new MutationObserver((mutations, obs) => {
        if (entranceAnimation.children.length > 0) {
            // All child elements have finished rendering
            obs.disconnect(); // Stop observing

            // Wait for 3 seconds before executing the function
            setTimeout(endEntranceAnimation, 3000);
        }
    });

    // Start observing the entranceAnimation element for child elements
    observer.observe(entranceAnimation, {
        childList: true,
        subtree: true,
    });

    // Set an item in local storage so the animation won't run again
    /*localStorage.setItem('animationEntranceShown', 'true');
    } else {
        // Hide #entrance-animation if it has already been shown
        if (entranceAnimation) {
            entranceAnimation.style.display = 'none';
        }

        // Remove the top margin from #content if it has already been shown
        const content = document.getElementById('content');
        if (content) {
            content.style.marginTop = '0';
        }
    }*/
}
